// Auto-generated by scripts/generate-music-manifest.js — do not edit manually
import song0 from "./ After You've Gone - Jimin Park.mid";
import song1 from "./Good Looking - Suki Waterhouse .mid";
import song2 from "./Le Cygne - Godowsky .mid";
import song3 from "./Liebestraum No.3.mid";
import song4 from "./Mia & Sebastian’s Theme (Arr Mercuzio).MID";
import song5 from "./Winter Wind (Etude op25 n11 ).mid";

export default [
  { name: " After You've Gone - Jimin Park", file: song0 },
  { name: "Good Looking - Suki Waterhouse ", file: song1 },
  { name: "Le Cygne - Godowsky ", file: song2 },
  { name: "Liebestraum No.3", file: song3 },
  { name: "Mia & Sebastian’s Theme (Arr Mercuzio)", file: song4 },
  { name: "Winter Wind (Etude op25 n11 )", file: song5 }
];
